<template>
  <div class="nlp__block-coins-box">
    <div class="nlp__block-coins-info">
      <div class="nlp__block-coins-info-left">
        <h2>Authorities and <span>Crypto</span> Issuers Can Block Coins</h2>
      </div>
      <div class="nlp__block-coins-info-right">
        <p>Funds can be frozen just for touching flagged wallets. Authorities and issuers like Tether, which issues USDT, have the power to block addresses and freeze funds. Restoring access to a frozen account can take months or even more until the investigation is resolved.</p>
      </div>
    </div>
    <div class="nlp__block-coins-amounts">
      <div
        v-for="(item, index) in amountsData"
        :key="index"
        class="nlp__block-coins-amounts-item"
      >
        <div class="nlp__block-coins-amounts-item-value">
          {{ item.value }}
        </div>
        <div class="nlp__block-coins-amounts-item-description">
          <div class="nlp__block-coins-amounts-item-icon">
            <component :is="item.icon" />
          </div>
          <p>{{ item.description }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Components
import NlpLock from '@/pages/landing-page/svg/NlpLock.vue'
import NlpSnowflake from '@/pages/landing-page/svg/NlpSnowflake.vue'

export default {
  name: 'NlpBlockCoins',
  components: {
    NlpLock,
    NlpSnowflake,
  },
  data() {
    return {
      amountsData: [
        {
          value: '$1.3B+',
          description: 'USDT blocked by Tether as of 2025',
          icon: NlpLock,
        },
        {
          value: '$7.7M',
          description: 'Blocked by U.K. authorities in a year',
          icon: NlpLock,
        },
        {
          value: '$26M+',
          description: 'By U.S. law enforcement in just 1 case',
          icon: NlpSnowflake,
        },
      ],
    }
  },
}
</script>

<style scoped>
.nlp__block-coins-info {
  display: flex;
  gap: 60px;
  margin-bottom: 60px;
}
.nlp__block-coins-info h2 {
  text-align: left;
}
.nlp__block-coins-info-left,
.nlp__block-coins-info-right {
  flex: 1;
}

.nlp__block-coins-amounts {
  display: flex;
  gap: 48px;
}
.nlp__block-coins-amounts-item {
  position: relative;
}
.nlp__block-coins-amounts-item + .nlp__block-coins-amounts-item:before {
  content: '';
  width: 1px;
  height: 86px;
  background-color: #E2E9F6;
  position: absolute;
  top: 50%;
  left: -24px;
  transform: translate(0, -50%);
}
.nlp__block-coins-amounts-item-value {
  margin-bottom: 16px;
  font-weight: 900;
  font-size: 44px;
  line-height: 58px;
  color: #1C1C1C;
}
.nlp__block-coins-amounts-item-description {
  display: flex;
  align-items: center;
  gap: 8px;
}
.nlp__block-coins-amounts-item-description p {
  font-size: 20px;
  line-height: 28px;
}


@media (max-width: 1279px) {
  .nlp__block-coins-box {
    max-width: 560px;
    margin: 0 auto;
    text-align: center;
  }
  .nlp__block-coins-info {
    display: block;
  }
  .nlp__block-coins-info h2 {
    text-align: center;
  }
  .nlp__block-coins-info-left {
    margin-bottom: 16px;
  }
  .nlp__block-coins-amounts {
    display: block;
  }
  .nlp__block-coins-amounts-item + .nlp__block-coins-amounts-item {
    margin-top: 80px;
  }
  .nlp__block-coins-amounts-item + .nlp__block-coins-amounts-item:before {
    width: 86px;
    height: 1px;
    top: -40px;
    left: 50%;
    transform: translate(-50%, 0);
  }
  .nlp__block-coins-amounts-item-description {
    justify-content: center;
  }
}
@media (max-width: 767px) {
  .nlp__block-coins-info {
    margin-bottom: 40px;
  }
  .nlp__block-coins-amounts-item-description {
    display: block;
  }
  .nlp__block-coins-amounts-item-icon {
    display: flex;
    justify-content: center;
    margin-bottom: 8px;
  }
}
</style>